/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipping_Adjustment_Create_FailedInputs */

const en_shipping_adjustment_create_failed = /** @type {(inputs: Shipping_Adjustment_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to create adjustment`)
};

const es_shipping_adjustment_create_failed = /** @type {(inputs: Shipping_Adjustment_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo crear el ajuste`)
};

/**
* | output |
* | --- |
* | "Failed to create adjustment" |
*
* @param {Shipping_Adjustment_Create_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const shipping_adjustment_create_failed = /** @type {((inputs?: Shipping_Adjustment_Create_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_Adjustment_Create_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shipping_adjustment_create_failed(inputs)
	return es_shipping_adjustment_create_failed(inputs)
});